/**
 * The host of a full http(s) URL — "www.sec.gov", with a port if it has
 * one — or null for anything else: a relative path, an anchor, mailto:,
 * javascript:, data:, junk. Untrusted text (projects/investing D8) keeps a
 * link only when this names its host, and shows that host beside it.
 *
 * Internationalised hosts come back in punycode ("xn--…"), so a look-alike
 * domain can't pass for the one it imitates.
 */
export function httpHost(href) {
  try {
    // No base: a relative path, an anchor, null and "" all throw. http(s)
    // URLs always have a host — "https://" alone throws too.
    const url = new URL(href);
    if (url.protocol !== "http:" && url.protocol !== "https:") return null;
    return url.host;
  } catch {
    return null;
  }
}
